import _taggedTemplateLiteral from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import styled from "styled-components";
import { Input as RawInput } from "../../Input";
var Label = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n"]))),
    ZipCode = styled(RawInput)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export { Label, ZipCode };